var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8008 4.36881C18.1438 1.87113 14.8 5.55298 14.8 5.55298C14.8 5.55298 11.4561 1.87112 6.79909 4.3688C1.15859 7.39396 0.753561 19.2407 14.8 24.5C28.8465 19.2407 28.4413 7.39397 22.8008 4.36881Z",
    stroke: "#003636",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartlight);
export default __webpack_public_path__ + "static/media/heartlight.b85d280befdb8364f028683557b48c34.svg";
export { ForwardRef as ReactComponent };